import { VsAlert } from '@vuesax-plus/components/alert'
// import { VsAvatar } from '@vuesax-plus/components/avatar'
// import { VsButton, VsButtonGroup } from '@vuesax-plus/components/button'
// import { VsCard } from '@vuesax-plus/components/card'
// import {
//   VsCheckbox,
//   VsCheckboxGroup,
// } from '@vuesax-plus/components/checkbox'
// import { VsCol } from '@vuesax-plus/components/col'
import { VsCollapseTransition } from '@vuesax-plus/components/collapse-transition'
// import { VsDialog } from '@vuesax-plus/components/dialog'
import { VsIcon } from '@vuesax-plus/components/icon'
// import { VsInput } from '@vuesax-plus/components/input'
// import { VsPagination } from '@vuesax-plus/components/pagination'
// import {
//   VsRadio,
//   VsRadioGroup,
// } from '@vuesax-plus/components/radio'
import { VsRate } from '@vuesax-plus/components/rate'
// import { VsRow } from '@vuesax-plus/components/row'
import { VsScrollbar } from '@vuesax-plus/components/scrollbar'
// import {
//   VsOption,
//   VsOptionGroup,
//   VsSelect,
// } from '@vuesax-plus/components/select'
// import { VsSwitch } from '@vuesax-plus/components/switch'
// import { VsTable } from '@vuesax-plus/components/table'
// import { VsTooltip } from '@vuesax-plus/components/tooltip'

import type { Plugin } from 'vue'

export default [
  VsAlert,
  // VsAvatar,
  // VsButton,
  // VsButtonGroup,
  // VsCard,
  // VsCheckbox,
  // VsCheckboxGroup,
  // VsCol,
  VsCollapseTransition,
  // VsDialog,
  VsIcon,
  // VsInput,
  // VsPagination,
  // VsRadio,
  // VsRadioGroup,
  VsRate,
  // VsRow,
  VsScrollbar,
  // VsSelect,
  // VsOption,
  // VsOptionGroup,
  // VsSwitch,
  // VsTable,
  // VsTooltip,
] as Plugin[]
